export default "__VITE_ASSET__I5RFX9k9__"